module.exports = __webpack_public_path__ + "static/media/logo.195699ed.png";